import { render, staticRenderFns } from "./ResubmitWithdrawal.vue?vue&type=template&id=4579c9c5"
import script from "./ResubmitWithdrawal.vue?vue&type=script&lang=js"
export * from "./ResubmitWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./ResubmitWithdrawal.vue?vue&type=style&index=0&id=4579c9c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports